export default __webpack_public_path__ + "static/media/jobticket.7d50b60f.svg";